export default __webpack_public_path__ + "static/media/c5.0c34caae.png";